<header class="page-header-large">
  <div class="container-fluid">
    <div class="text-center d-flex justify-content-between align-items-center">
      <a><img src="assets/images/satyamev_jayate-blue.png" alt="CWMI"></a>
      <!-- class="logo_gec handpointer" -->

      <a class="en-main-title">
        <!-- <img class="main-title" src="assets/images/logo-nmcg-english.svg" alt="cgwb"> -->

        <h5 class="mb-0">National Mission for Clean Ganga</h5>
        <p class="mb-0">Department of Water Resource, River Development & Ganga Rejuvenation Ministry
          of Jal Shakti,
          Government of
          India</p>
      </a>
      <a><img src="assets/images/nmcgGif.gif" alt="CWMI" class="gif-image"></a>
    </div>
  </div>

</header>

<body class="h-auto">
  <div style="background-color: white; min-height: 700px;">

    <div class="row">
      <div class="col-auto ml-4">
        <div class="float-left" >
          <label>Assessment Year
            <!-- <span class="required-field">*</span> -->
          </label>
          <select [(ngModel)]="dgcGraphFilter['ay']" class="form-control custom-selectbox w-100">
            <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
          </select>
        </div>
      </div>
      
      <!-- <div class="col-12 col-xl col-md-6" *ngIf="dgcGraphFilter['lu'] == 'All'">
        <div class="form-group" >
          <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="dgcGraphFilter['month']" class="form-control custom-selectbox">
            <option value="" [disabled]="true">{{'dataSubs.selectmonth' | translate}}</option>
            <option  *ngFor="let month of monthsList"  [value]="month.key">
              {{'monthmaps.' + month['value'] | translate}}</option>
          </select>
        </div>
      </div>         -->
      <div class="form-group">
        <label class="w-100">&nbsp;&nbsp;<span class="required-field"></span></label>
        <button class="btn btn-info pointer" (click)="getGraphData()" type="submit">VIEW</button>         
      </div>  
    
  </div>

    <div class="row p-4" *ngIf="showTwoCharts && !showTable">
        <div class="col-md-6 col-sm-12">
          <div id="double-column-chart" class="pointer border"></div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div id="line-chart" class="pointer border"></div>
        </div>
    </div>

    <div *ngIf="!showTwoCharts && !showTable" class="border p-4 mx-4">
      <div>
        <button (click)="ngOnInit()">Back</button>
      </div>
      <div id="single-column-chart" class="mt-5 pointer"></div>  
    </div>

    <div *ngIf="showTable" class="mx-4 border p-4">
      <div>
        <button (click)="ngOnInit()">Back</button>
      </div>
      <div class="table-responsive mt-2">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>S.no</th>
              <th (click)="sortRows('name')">DGC Names <i class="fas fa-sort pointer"></i></th>
              <th (click)="sortRows('status')">Status <i class="fas fa-sort pointer"></i></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dgc of dgcTableData; let i = index">
              <td>{{i+1}}</td>
              <td>{{dgc['name']}}</td>
              <td>{{dgc['status']}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  
  </div>
</body>

